var daggy = require('daggy'),

    Unit = daggy.tagged();

// Export
if (typeof module != 'undefined')
    module.exports = Unit;